export interface AlternativeDTO {
	name: string;
	value?: string;
}

export interface QuestionDTO {
	id: number;
	header?: string
	title: string;
	text?: boolean;
	alternatives?: AlternativeDTO[];
}

const defaultAlternatives: AlternativeDTO[] = [
	{ name: "😀 - Nunca", value: "1" },
	{ name: "🙂 - Raramente", value: "2" },
	{ name: "😐 - Às vezes", value: "3" },
	{ name: "🙁 - Frequentemente", value: "4" },
	{ name: "☹️ - Sempre", value: "5" },
];

const defaultAlternatives5: AlternativeDTO[] = [
	{ name: "☹️ - Nunca", value: "1" },
	{ name: "🙁 - Raramente", value: "2" },
	{ name: "😐 - Às vezes", value: "3" },
	{ name: "🙂 - Frequentemente", value: "4" },
	{ name: "😀 - Sempre", value: "5" },
];

const defaultAlternatives2: AlternativeDTO[] = [
	{ name: "☹️ - Nada/quase nada", value: "1" },
	{ name: "🙁 - Um pouco", value: "2" },
	{ name: "😐 - Moderadamente", value: "3" },
	{ name: "🙂 - Muito", value: "4" },
	{ name: "😀 - Extremamente", value: "5" },
];

const nadaFeliz: AlternativeDTO[] = [
	{ name: "😀 - Nada/quase nada", value: "1" },
	{ name: "🙂 - Um pouco", value: "2" },
	{ name: "😐 - Moderadamente", value: "3" },
	{ name: "🙁 - Muito", value: "4" },
	{ name: "☹️ - Extremamente", value: "5" },
];

const smookingalternatives : AlternativeDTO[] = [
	{ name: "Nunca" },
	{ name: "quase todo dia" },
	{ name: "Só aos fins de semana" },
	{ name: "Todo dia" }
];

const defaultHeader = "Com que frequência durante as últimas 4 semanas sentiu…";
const defaultHeader2 = "Nos últimos 12 meses, no seu local de trabalho:";

export const formQuestions: QuestionDTO[] = [
	{
		id: 1,
		title: "Qual a sua faixa etária:",
		alternatives: [
			{ name: "Menor de 18 anos" },
			{ name: "Até 27 anos" },
			{ name: "De 28 a 43 anos" },
			{ name: "De 44 a 59 anos" },
			{ name: "+ 60 anos" }
		]
	},
	{
		id: 2,
		title: "Você se considera uma Pessoa com Deficiência (PCD) de acordo com a Lei nº 13.146/2015?",
		alternatives: [
			{ name: "SIM" },
			{ name: "NÃO" },
			{ name: "PREFIRO NÃO DIZER" }
		]
	},
	{
		id: 3,
		title: "Por favor, especifique qual(is) o(s) tipo(s) de deficiência(s) que você possui. Você pode incluir mais de um tipo, se for o caso. Exemplos: Deficiência Física (ex: mobilidade reduzida), Deficiência Visual, Deficiência Auditiva, Deficiência Intelectual, etc.",
		text: true
	},
	{
		id: 4,
		title: "Sexo:",
		alternatives: [
			{ name: "Feminino" },
			{ name: "Masculino" },
			{ name: "Intersex" },
			{ name: "Não binário" },
			{ name: "Outro" }
		]
	},
	{
		id: 5,
		title: "Estado civil:",
		alternatives: [
			{ name: "Casado(a) ou união estável" },
			{ name: "Divorciado(a) ou separado(a)" },
			{ name: "Solteiro(a)" },
			{ name: "Viúvo(a)" }
		]
	},
	{
		id: 6,
		title: "Filhos",
		alternatives: [
			{ name: "Menores de 14 anos" },
			{ name: "Maiores de 14 anos" },
			{ name: "Menores e maiores de 14 anos" },
			{ name: "Não tenho" }
		]
	},
	{
		id: 7,
		title: "Escolaridade (Completo/Incompleto):",
		alternatives: [
			{ name: "Não sou alfabetizado" },
			{ name: "Ensino Fundamental" },
			{ name: "Ensino Médio" },
			{ name: "Ensino Técnico" },
			{ name: "Ensino Superior" }
		]
	},
	{
		id: 8,
		title: "Quanto tempo você trabalha nesta empresa?",
		alternatives: [
			{ name: "Até 6 meses" },
			{ name: "De 7 meses e 1 ano" },
			{ name: "Entre 1 ano e 3 anos" },
			{ name: "Entre 3 anos e 5 anos" },
			{ name: "Mais que 5 anos" }
		]
	},
	{
		id: 9,
		title: "Você bebe com que frequência?",
		alternatives: smookingalternatives
	},
	{
		id: 10,
		title: "Você fuma com que frequência?",
		alternatives: smookingalternatives
	},
	{
		id: 11,
		title: "Em uma escala de 0 a 10, o quanto você indica esta empresa para um amigo seu trabalhar?",
		alternatives: [
			{ name: "0 - Nunca indicaria", value: "0" },
			{ name: "1", value: "1" },
			{ name: "2", value: "2" },
			{ name: "3", value: "3" },
			{ name: "4", value: "4" },
			{ name: "5", value: "5" },
			{ name: "6", value: "6" },
			{ name: "7", value: "7" },
			{ name: "8", value: "8" },
			{ name: "9 ", value: "9" },
			{ name: "10 - Indicaria com orgulho", value: "10" },
		]
	},
	{
		id: 12,
		title: "1. A sua carga de trabalho acumula-se por ser mal distribuída?",
		alternatives: defaultAlternatives
	},
	{
		id: 13,
		title: "2. Com que frequência não tem tempo para completar todas as tarefas do seu trabalho",
		alternatives: defaultAlternatives
	},
	{
		id: 14,
		title: "3. Precisa fazer horas extras?",
		alternatives: defaultAlternatives
	},
	{
		id: 15,
		title: "4. Precisa trabalhar muito rapidamente?",
		alternatives: defaultAlternatives
	},
	{
		id: 16,
		title: "5. O seu trabalho exige a sua atenção constante?",
		alternatives: defaultAlternatives
	},
	{
		id: 17,
		title: "6. O seu trabalho requer que seja bom a propor novas ideias?",
		alternatives: defaultAlternatives
	},
	{
		id: 18,
		title: "7. O seu trabalho exige que tome decisões difíceis?",
		alternatives: defaultAlternatives
	},
	{
		id: 19,
		title: "8. O seu trabalho exige emocionalmente de si?",
		alternatives: defaultAlternatives
	},
	{
		id: 20,
		title: "9. Tem um elevado grau de influência no seu trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 21,
		title: "10. Participa na escolha das pessoas com quem trabalha?",
		alternatives: defaultAlternatives5
	},
	{
		id: 22,
		title: "11. Pode influenciar a quantidade de trabalho que lhe compete a si?",
		alternatives: defaultAlternatives5
	},
	{
		id: 23,
		title: "12. Tem alguma influência sobre o tipo de tarefas que faz?",
		alternatives: defaultAlternatives5
	},
	{
		id: 24,
		title: "13. O seu trabalho exige que tenha iniciativa?",
		alternatives: defaultAlternatives5
	},
	{
		id: 25,
		title: "14. O seu trabalho permite-lhe aprender coisas novas?",
		alternatives: defaultAlternatives5
	},
	{
		id: 26,
		title: "15. O seu trabalho permite-lhe usar as suas habilidades ou perícias?",
		alternatives: defaultAlternatives5
	},
	{
		id: 27,
		title: "16. No seu local de trabalho, é informado com antecedência sobre decisões importantes, mudanças ou planos para o futuro?",
		alternatives: defaultAlternatives5
	},
	{
		id: 28,
		title: "17. Recebe toda a informação de que necessita para fazer bem o seu trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 29,
		title: "18. O seu trabalho apresenta objetivos claros?",
		alternatives: defaultAlternatives5
	},
	{
		id: 30,
		title: "19. Sabe exatamente quais as suas responsabilidades?",
		alternatives: defaultAlternatives5
	},
	{
		id: 31,
		title: "20. Sabe exatamente o que é esperado de si?",
		alternatives: defaultAlternatives5
	},
	{
		id: 32,
		title: "21. O seu trabalho é reconhecido e apreciado pela gerência?",
		alternatives: defaultAlternatives5
	},
	{
		id: 33,
		title: "22. A gerência do seu local de trabalho respeita-o?",
		alternatives: defaultAlternatives5
	},
	{
		id: 34,
		title: "23. É tratado de forma justa no seu local de trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 35,
		title: "24. Faz coisas no seu trabalho que uns concordam, mas outros não?",
		alternatives: defaultAlternatives
	},
	{
		id: 36,
		title: "25. Por vezes, tem que fazer coisas que deveriam ser feitas de outra maneira?",
		alternatives: defaultAlternatives
	},
	{
		id: 37,
		title: "26. Por vezes, tem que fazer coisas que considera desnecessárias?",
		alternatives: defaultAlternatives
	},
	{
		id: 38,
		title: "27. Com que frequência tem ajuda e apoio dos seus colegas de trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 39,
		title: "28. Com que frequência os seus colegas estão dispostos a ouvi-lo(a) sobre os seus problemas de trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 40,
		title: "29. Com que frequência os seus colegas falam consigo acerca do seu desempenho laboral?",
		alternatives: defaultAlternatives5
	},
	{
		id: 41,
		title: "30. Com que frequência o seu superior imediato fala consigo sobre como está a decorrer o seu trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 42,
		title: "31. Com que frequência tem ajuda e apoio do seu superior imediato?",
		alternatives: defaultAlternatives5
	},
	{
		id: 43,
		title: "32. Com que frequência é que o seu superior imediato fala consigo em relação ao seu desempenho laboral?",
		alternatives: defaultAlternatives5
	},
	{
		id: 44,
		title: "33. Existe um bom ambiente de trabalho entre si e os seus colegas?",
		alternatives: defaultAlternatives5
	},
	{
		id: 45,
		title: "34. Existe uma boa cooperação entre os colegas de trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 46,
		title: "35. No seu local de trabalho sente-se parte de uma comunidade?",
		alternatives: defaultAlternatives5
	},
	{
		id: 47,
		title: "36. Seu chefe oferece aos indivíduos e ao grupo boas oportunidades de desenvolvimento?",
		alternatives: defaultAlternatives5
	},
	{
		id: 48,
		title: "37. Seu chefe dá prioridade à satisfação no trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 49,
		title: "38. Seu chefe é bom no planejamento do trabalho?",
		alternatives: defaultAlternatives5
	},
	{
		id: 50,
		title: "39. Seu chefe é bom a resolver conflitos?",
		alternatives: defaultAlternatives5
	},
	{
		id: 51,
		title: "40. Os funcionários ocultam informações uns dos outros?",
		alternatives: defaultAlternatives
	},
	{
		id: 52,
		title: "41. Os funcionários ocultam informação à gerência?",
		alternatives: defaultAlternatives
	},
	{
		id: 53,
		title: "42. Os funcionários confiam uns nos outros de um modo geral?",
		alternatives: defaultAlternatives
	},
	{
		id: 54,
		title: "43. A gerência confia nos seus funcionários para fazerem o seu trabalho bem?",
		alternatives: defaultAlternatives5
	},
	{
		id: 55,
		title: "44. Confia na informação que lhe é transmitida pela gerência?",
		alternatives: defaultAlternatives5
	},
	{
		id: 56,
		title: "45. A gerência oculta informação aos seus funcionários?",
		alternatives: defaultAlternatives5
	},
	{
		id: 57,
		title: "46. Os conflitos são resolvidos de uma forma justa?",
		alternatives: defaultAlternatives5
	},
	{
		id: 58,
		title: "47. As sugestões dos funcionários são tratadas de forma séria pela gerência?",
		alternatives: defaultAlternatives5
	},
	{
		id: 59,
		title: "48. O trabalho é igualmente distribuído pelos funcionários?",
		alternatives: defaultAlternatives5
	},
	{
		id: 60,
		title: "49. Sou sempre capaz de resolver problemas, se tentar o suficiente?",
		alternatives: defaultAlternatives5
	},
	{
		id: 61,
		title: "50. É fácil seguir os meus planos e atingir os meus objetivos?",
		alternatives: defaultAlternatives5
	},
	{
		id: 62,
		title: "51. O seu trabalho tem algum significado para si?",
		alternatives: defaultAlternatives2
	},
	{
		id: 63,
		title: "52. Sente que o seu trabalho é importante?",
		alternatives: defaultAlternatives2
	},
	{
		id: 64,
		title: "53. Sente-se motivado e envolvido com o seu trabalho?",
		alternatives: defaultAlternatives2
	},
	{
		id: 65,
		title: "54. Gosta de falar com os outros sobre o seu local de trabalho?",
		alternatives: defaultAlternatives2
	},
	{
		id: 66,
		title: "55. Sente que os problemas do seu local de trabalho são seus também?",
		alternatives: defaultAlternatives2
	},
	{
		id: 67,
		title: "56. Sente-se satisfeito com as suas perspectivas de trabalho?",
		alternatives: defaultAlternatives2
	},
	{
		id: 68,
		title: "57. Sente-se satisfeito com as condições físicas do seu local de trabalho?",
		alternatives: defaultAlternatives2
	},
	{
		id: 69,
		title: "58. Sente-se satisfeito com a forma como as suas capacidades são utilizadas?",
		alternatives: defaultAlternatives2
	},
	{
		id: 70,
		title: "59. Sente-se satisfeito com seu trabalho de uma forma global?",
		alternatives: defaultAlternatives2
	},
	{
		id: 71,
		title: "60. Sente-se preocupado em ficar desempregado?",
		alternatives: nadaFeliz
	},
	{
		id: 72,
		title: "61. Em geral, sente que a sua saúde é:",
		alternatives: [
			{ name: "Excelente", value: "1" },
			{ name: "Muito boa", value: "2" },
			{ name: "Boa", value: "3" },
			{ name: "Razoável", value: "4" },
			{ name: "Deficitária", value: "5" },
		]
	},
	{
		id: 73,
		title: "62. Sente que o seu trabalho lhe exige muita energia que acaba por afetar a sua vida privada negativamente?",
		alternatives: nadaFeliz
	},
	{
		id: 74,
		title: "63. Sente que o seu trabalho lhe exige muito tempo que acaba por afetar a sua vida privada negativamente?",
		alternatives: nadaFeliz
	},
	{
		id: 75,
		title: "64. A sua família e os seus amigos dizem-lhe que trabalha demais?",
		alternatives: nadaFeliz
	},
	{
		id: 76,
		header: defaultHeader,
		title: "65. Dificuldades para adormecer",
		alternatives: defaultAlternatives
	},
	{
		id: 77,
		header: defaultHeader,
		title: "66. Acordou várias vezes durante a noite e depois não conseguia adormecer novamente",
		alternatives: defaultAlternatives
	},
	{
		id: 78,
		header: defaultHeader,
		title: "67. Fisicamente exausto",
		alternatives: defaultAlternatives
	},
	{
		id: 79,
		header: defaultHeader,
		title: "68. Emocionalmente exausto",
		alternatives: defaultAlternatives
	},
	{
		id: 80,
		header: defaultHeader,
		title: "69. Irritado",
		alternatives: defaultAlternatives
	},
	{
		id: 81,
		header: defaultHeader,
		title: "70. Ansioso",
		alternatives: defaultAlternatives
	},
	{
		id: 82,
		header: defaultHeader,
		title: "71. Triste",
		alternatives: defaultAlternatives
	},
	{
		id: 83,
		header: defaultHeader,
		title: "72. Falta de interesse por coisas cotidianas",
		alternatives: defaultAlternatives
	},
	{
		id: 84,
		header: defaultHeader2,
		title: "73. Tem sido alvo de insultos ou provocações verbais?",
		alternatives: defaultAlternatives
	},
	{
		id: 85,
		header: defaultHeader2,
		title: "74. Tem sido exposto a assédio sexual indesejado?",
		alternatives: defaultAlternatives
	},
	{
		id: 86,
		header: defaultHeader2,
		title: "75. Tem sido exposto a ameaças de violência?",
		alternatives: defaultAlternatives
	},
	{
		id: 87,
		header: defaultHeader2,
		title: "76. Tem sido exposto a violência física?",
		alternatives: defaultAlternatives
	},
	{
		id: 88,
		title: "Pensando na saúde mental no trabalho, quais ações ou programas a empresa oferece para te ajudar a lidar com o estresse e outros desafios emocionais?",
		text: true
	},
	{
		id: 89,
		title: "Na sua opinião, o que a empresa poderia fazer para evitar que o ambiente de trabalho prejudique a saúde mental dos trabalhadores?",
		text: true
	},
	{
		id: 90,
		title: "Ao responder este questionário, você consente com o uso dos dados pela empresa para avaliar riscos psicossociais, melhorar o ambiente de trabalho e gerar relatórios sem identificação individual. Estes dados serão tratados com sigilo e segurança, conforme a LGPD. Se desejar obter mais informações, entre em contato com o responsável pela saúde e segurança ocupacional da sua empresa.",
		alternatives: [
			{ name: "Ciente" }
		]
	}
];